import React from "react";
import "./contact.css";

const ContactHero = ({ title, paragraphs = [], variant = "" }) => {
  const cls = ["contact-hero", variant ? `contact-hero--${variant}` : ""].filter(Boolean).join(" ");
  return (
    <section className={cls}>
      <div className="container">
        <div
          className="contact-hero-content"
          data-aos="fade-up"
          data-aos-duration="1200"
          data-aos-once="true"
        >
          <h1>{title}</h1>
          {paragraphs.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
          <div className="contact-hero-actions">
            <a
              href="tel:+971544792905"
              className="mini-btn primary"
            >
              Call Now
            </a>
            <a
              href="https://wa.me/971544792905?text=Hi, I need refrigerated transport in UAE"
              target="_blank"
              rel="noopener noreferrer"
              className="mini-btn secondary"
            >
              WhatsApp Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;
